var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOcWorkBalance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2046,
    height: 1390,
    viewBox: "0 0 2046 1390",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M826.104 1235.11C864.342 1117.68 927.193 918.65 945.083 834.791C945.158 834.441 945.368 834.156 945.673 833.967C1023.63 785.478 1107.95 759.1 1136.32 753.836C1136.66 753.772 1137 753.86 1137.29 754.06C1209.52 804.558 1254.21 835.422 1281.83 861.697C1352.08 928.519 1365.45 1056.65 1364.23 1140.05C1364.23 1140.52 1363.96 1140.94 1363.55 1141.17L1334.59 1157.17C1333.88 1157.57 1332.99 1157.23 1332.7 1156.47C1309.06 1092.93 1264.98 1042.78 1236.13 951.654C1236.15 952.392 1235.52 953.041 1234.74 953.022C1156.36 951.019 1153.21 946.505 1082.48 924.892C1040.27 1059.52 919.738 1192.36 859.947 1249.5C859.57 1249.86 859.035 1249.95 858.553 1249.75L826.865 1236.72C826.226 1236.46 825.89 1235.77 826.104 1235.11Z",
    fill: "#BAC3D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1039.22 457.271C1045.82 447.371 1117.59 420.981 1090.98 327.674C1114.16 317.342 1118.01 292.694 1096.7 292.704C1073.51 291.659 1066.75 273.261 1065.34 261.239C1064.43 245.038 1058.13 230.488 1055.58 228.011",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1057.15 304.474C1060.21 303.111 1061.03 298.286 1058.99 293.699C1056.94 289.111 1052.8 286.497 1049.75 287.861C1046.69 289.224 1045.87 294.049 1047.91 298.636C1049.96 303.224 1054.09 305.838 1057.15 304.474Z",
    fill: "#BAC3D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1030.11 282.724C1032.07 276.843 1039.25 266.255 1052.32 270.944",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1040.81 374.79C1052.88 382.416 1062.06 381.936 1073.9 367.984",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M947.876 325.167C947.892 329.516 950.276 338.311 959.675 338.696",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M849.758 325.552C863.358 378.745 908.408 402.775 941.811 421.814C958.139 400.082 980.911 355.79 965.868 359.06C950.057 362.494 916.907 330.303 925.338 311.913C935.23 290.337 959.752 304.819 969.977 319.65L972.673 290.81C961.62 276.589 947.303 249.31 978.468 253.961C1009.63 258.611 1042.88 238.343 1055.62 227.629C1074.9 193.838 1097.48 125.317 1033.58 121.554C980.432 118.424 938.129 172.742 916.12 214.188C890.379 218.687 831.214 253.025 849.758 325.552Z",
    fill: "#BAC3D7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M941.895 417.792C958.014 425.51 967.938 433.511 977.178 455.292",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M957.736 611.837C962.731 647.023 965.84 740.619 938.992 836.484C938.653 837.696 940.025 838.695 941.056 837.973C969.786 817.852 1044.84 775.683 1141.42 750.732C1142.06 750.565 1142.48 749.979 1142.41 749.321C1136.13 696.197 1132.75 584.523 1163.41 555.313C1163.58 555.154 1163.77 555.051 1164 554.999C1227.23 540.402 1361.4 493.899 1400.53 421.254C1400.58 421.146 1400.62 421.035 1400.65 420.915C1403.46 407.782 1405.39 380.963 1391.14 376.345C1390.87 376.254 1390.56 376.27 1390.29 376.381C1296.89 414.146 1192.8 445.427 1059.02 469.152",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M957.737 656.719C893.847 726.417 834.395 752.96 789.074 772.761C757.412 788.902 688.751 800.482 719.47 750.442C851.473 585.701 880.514 557.056 911.535 528.675C929.352 512.375 937.276 502.274 982.157 490.394",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M772.931 1285.06C770.291 1267.9 821.553 1242.82 830.354 1238.2L857.414 1248.76C855.302 1261.96 848.614 1269.66 845.534 1271.86L772.931 1285.06Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1347.15 1179.45C1336.59 1177.34 1336.15 1162.29 1337.25 1155.03L1361.01 1143.15C1368.27 1145.13 1387.67 1150.28 1407.21 1155.03C1426.74 1159.79 1424.14 1166.25 1420.41 1168.89L1347.15 1179.45Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M1210.03 1307.5C1210.03 1353.07 1173.09 1390 1127.53 1390C1081.96 1390 1045.02 1353.07 1045.02 1307.5C1045.02 1261.93 1081.96 1225 1127.53 1225C1173.09 1225 1210.03 1261.93 1210.03 1307.5Z",
    fill: "#BAC3D7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M644.886 1317.4L1608.51 1140.51",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M1491.03 207.906H1435.59C1430.12 207.906 1425.69 212.338 1425.69 217.806V258.727C1425.69 264.195 1430.12 268.628 1435.59 268.628H1491.03C1496.5 268.628 1500.93 264.195 1500.93 258.727V217.806C1500.93 212.338 1496.5 207.906 1491.03 207.906Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1584.75 192.065H1547.79C1542.32 192.065 1537.89 196.498 1537.89 201.966V254.767C1537.89 260.235 1542.32 264.668 1547.79 264.668H1584.75C1590.22 264.668 1594.65 260.235 1594.65 254.767V201.966C1594.65 196.498 1590.22 192.065 1584.75 192.065Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M1678.47 159.064H1642.83C1637.37 159.064 1632.93 163.497 1632.93 168.965V254.767C1632.93 260.235 1637.37 264.667 1642.83 264.667H1678.47C1683.94 264.667 1688.38 260.235 1688.38 254.767V168.965C1688.38 163.497 1683.94 159.064 1678.47 159.064Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1774.84 125.404H1737.88C1730.59 125.404 1724.68 131.314 1724.68 138.604V254.768C1724.68 262.058 1730.59 267.968 1737.88 267.968H1774.84C1782.13 267.968 1788.04 262.058 1788.04 254.768V138.604C1788.04 131.314 1782.13 125.404 1774.84 125.404Z",
    fill: "#BAC3D7"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1872.52 186.785H1836.88C1831.41 186.785 1826.98 191.218 1826.98 196.685V254.767C1826.98 260.235 1831.41 264.667 1836.88 264.667H1872.52C1877.99 264.667 1882.42 260.235 1882.42 254.767V196.685C1882.42 191.218 1877.99 186.785 1872.52 186.785Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1971.52 219.786H1934.56C1929.09 219.786 1924.66 224.219 1924.66 229.686V254.767C1924.66 260.235 1929.09 264.667 1934.56 264.667H1971.52C1976.99 264.667 1981.42 260.235 1981.42 254.767V229.686C1981.42 224.219 1976.99 219.786 1971.52 219.786Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M1757.03 107.261C1755.97 108.476 1754.1 108.476 1753.04 107.261L1741.67 94.1319C1740.19 92.4222 1741.4 89.7627 1743.66 89.7627H1766.42C1768.67 89.7627 1769.89 92.4222 1768.41 94.1319L1757.03 107.261Z",
    fill: "#BAC3D7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1693 0H1821.04C1828.33 0 1834.24 5.91001 1834.24 13.2004V84.4824C1834.24 91.7728 1828.33 97.6828 1821.04 97.6828H1693C1685.7 97.6828 1679.79 91.7728 1679.79 84.4824V13.2004C1679.79 5.91001 1685.7 0 1693 0ZM1727.32 44.8813H1811.8C1814.71 44.8813 1817.08 47.2453 1817.08 50.1614C1817.08 53.0776 1814.71 55.4416 1811.8 55.4416H1727.32C1724.4 55.4416 1722.04 53.0776 1722.04 50.1614C1722.04 47.2453 1724.4 44.8813 1727.32 44.8813ZM1702.24 47.2013C1700.6 47.2013 1699.28 48.5266 1699.28 50.1614C1699.28 51.7963 1700.6 53.1216 1702.24 53.1216C1703.87 53.1216 1705.2 51.7963 1705.2 50.1614C1705.2 48.5266 1703.87 47.2013 1702.24 47.2013ZM1697.28 50.1614C1697.28 47.422 1699.5 45.2013 1702.24 45.2013C1704.98 45.2013 1707.2 47.422 1707.2 50.1614C1707.2 52.9008 1704.98 55.1216 1702.24 55.1216C1699.5 55.1216 1697.28 52.9008 1697.28 50.1614ZM1727.32 69.962H1761.64C1764.55 69.962 1766.92 72.326 1766.92 75.2422C1766.92 78.1583 1764.55 80.5223 1761.64 80.5223H1727.32C1724.4 80.5223 1722.04 78.1583 1722.04 75.2422C1722.04 72.326 1724.4 69.962 1727.32 69.962ZM1736.56 18.4805H1702.24C1699.32 18.4805 1696.96 20.8445 1696.96 23.7607C1696.96 26.6768 1699.32 29.0408 1702.24 29.0408H1736.56C1739.47 29.0408 1741.84 26.6768 1741.84 23.7607C1741.84 20.8445 1739.47 18.4805 1736.56 18.4805ZM1702.24 69.962C1705.15 69.962 1707.52 72.326 1707.52 75.2422C1707.52 78.1583 1705.15 80.5223 1702.24 80.5223C1699.32 80.5223 1696.96 78.1583 1696.96 75.2422C1696.96 72.326 1699.32 69.962 1702.24 69.962Z",
    fill: "#BAC3D7"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M262.023 1022.98C282.769 1012.32 306.433 1008.73 329.41 1012.76C352.385 1016.79 373.411 1028.23 389.281 1045.33C405.152 1062.43 414.996 1084.24 417.312 1107.45C419.628 1130.67 414.29 1154 402.111 1173.9C389.932 1193.79 371.581 1209.16 349.855 1217.65C328.129 1226.15 304.222 1227.31 281.778 1220.95C259.333 1214.59 239.584 1201.07 225.54 1182.44C211.497 1163.81 203.931 1141.11 203.994 1117.78L310.917 1118.07L262.023 1022.98Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M184.193 1106.19C184.193 1086.88 189.554 1067.95 199.679 1051.51C209.803 1035.07 224.295 1021.76 241.537 1013.07L288.476 1106.19H184.193Z",
    fill: "#BAC3D7"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M1510.59 375.027C1512.1 378.532 1512.65 386.276 1504.01 390.973C1503.37 391.321 1502.67 391.653 1501.93 391.964C1491.12 396.48 1488.43 389.055 1488.43 384.778V380.421",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M1509.19 364.249C1512.1 366 1516.07 370.447 1510.59 375.027C1510.18 375.369 1509.72 375.71 1509.19 376.054C1502.87 380.218 1493.88 380.765 1488.43 380.42C1487.43 380.357 1486.55 380.265 1485.83 380.159C1482.89 379.337 1478.15 376.142 1482.71 369.945",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1507.12 351.417C1510.07 352.101 1515.12 354.805 1511.79 360.143C1508.47 365.48 1491.72 368.867 1483.76 369.894C1483.41 369.928 1483.07 369.946 1482.71 369.944C1479.57 369.932 1476.48 368.409 1476.48 364.248C1476.48 358.37 1484.1 356.378 1485.83 356.036",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M1489.71 333.97C1492.65 335.167 1494.45 339.511 1487.39 343.206C1480.32 346.901 1482.03 351.931 1483.76 353.984C1486.53 356.379 1495.49 358.192 1509.19 346.286C1522.91 334.379 1501.41 326.954 1488.43 324.729",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1459.35 346.285C1465.24 341.667 1476.69 335.2 1475.45 346.285C1474.2 357.371 1466.28 362.196 1462.46 363.223",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M1459.35 390.731C1462.79 387.768 1468.67 378.073 1464.52 363.01",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1461.87 342.684L1455.39 307.569",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M1485.09 301.629L1489.51 337.525",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1495.25 393.245C1495.25 403.047 1499.95 415.945 1489.51 419.041C1476.77 422.82 1475.43 411.302 1472.83 399.436L1466.04 363.837",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.03 329.35C1450.77 330.67 1433.74 338.062 1423.71 357.07C1413.68 376.079 1404.13 382.151 1400.61 382.811",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1402.59 415.812C1421.07 417.792 1459.22 417 1471.89 403.271",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M1458.69 306.909C1493.68 306.909 1522.05 278.541 1522.05 243.547C1522.05 208.553 1493.68 180.185 1458.69 180.185C1423.69 180.185 1395.33 208.553 1395.33 243.547C1395.33 278.541 1423.69 306.909 1458.69 306.909Z",
    stroke: "#BAC3D7",
    strokeWidth: 5
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M2042.73 366.374C2017.41 371.568 2029.28 406.43 2010.73 415.706C1988.58 426.78 1980.95 364.435 1983.83 337.972C1984.66 326.369 1998.16 321.209 1999.98 337.972C2001.92 355.779 1979.83 424.829 1954.51 398.184L1937.61 378.623C1932.91 372.834 1923.66 364.791 1915.83 378.623C1908 392.453 1895.53 387.883 1890.28 383.868L1873.76 371.852",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M1885.6 318.593L1754.15 296.327C1752.86 296.106 1752.07 297.724 1753.06 298.609L1813.94 353.442C1814.04 353.529 1814.14 353.602 1814.27 353.649C1819.65 355.768 1840.33 347.623 1851.33 342.697C1852.07 342.364 1852.93 342.771 1853.16 343.552C1855.69 352.431 1858.75 360.639 1860.32 364.551C1860.56 365.127 1861.19 365.445 1861.62 364.987C1864.56 361.74 1864.97 345.21 1864.76 335.723C1864.75 335.046 1865.23 334.472 1865.91 334.341C1874 332.761 1884.94 325.653 1889.6 322.136",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M1852.64 341.768C1838.62 335.315 1803.15 319.152 1773.44 306.127",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M1860.56 365.529L1834.16 349.689",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.28 328.568L1819.64 318.008",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M963.978 496.213C954.519 485.213 941.274 462.024 963.978 457.272C992.359 451.331 1056.38 452.651 1059.02 468.492",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M659.96 843.45C665.094 846.225 680.571 847.282 701.412 829.307C722.253 811.332 726.811 795.308 726.485 789.542",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M634.17 843.013C633.587 847.974 636.882 855.58 654.725 846.32L659.959 843.45L669.062 838.459",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M629.525 827.645C625.333 830.107 618.578 836.464 625.102 842.205C627.07 843.937 630.324 843.984 634.17 843.013C643.071 840.762 655.145 833.048 661.784 828.094",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M707.312 765.211C697.474 761.597 677.148 754.547 663.64 759.24C660.25 760.512 652.566 762.265 648.95 759.097C644.432 755.138 635.866 765.295 647.513 772.09C659.161 778.886 666.748 771.681 665.205 782.468C663.971 791.1 640.07 805.106 628.275 811.029C624.037 812.948 617.037 818.512 622.938 825.42C624.399 827.13 626.721 827.76 629.526 827.645C638.053 827.294 651.056 820.066 657.999 815.382",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M361.533 290.208C396.322 325.816 460.957 341.507 495.025 345.791C497.433 346.094 498.281 349.225 496.327 350.667L406.688 416.783C406.397 416.999 406.06 417.153 405.706 417.232C339.337 432.044 277.461 365.975 252.908 328.441C251.972 327.012 252.669 325.113 254.29 324.57L358.768 289.532C359.743 289.204 360.813 289.472 361.533 290.208Z",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M310.205 344.438C320.766 342.244 343.734 335.414 351.126 325.638",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M339.906 368.198C346.506 368.418 361.687 365.162 369.607 350.378",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M372.247 384.039C382.147 382.719 403.4 375.195 409.208 355.658",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M138.877 566.095C104.087 601.703 39.4522 617.395 5.38334 621.678C2.97559 621.982 2.12818 625.113 4.08183 626.554L93.7203 692.671C94.012 692.886 94.3486 693.041 94.7024 693.12C161.072 707.932 222.949 641.863 247.501 604.329C248.437 602.899 247.74 601.001 246.119 600.457L141.641 565.42C140.667 565.092 139.596 565.36 138.877 566.095Z",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M190.204 620.325C179.644 618.131 156.675 611.302 149.283 601.525",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M160.503 644.086C153.903 644.305 138.723 641.05 130.803 626.266",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M128.161 659.927C118.261 658.607 97.0084 651.082 91.2002 631.546",
    stroke: "#BAC3D7",
    strokeWidth: 5,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcWorkBalance);
export default __webpack_public_path__ + "static/media/oc-work-balance.a18032baf757e5cd8baac021cfb3ce5a.svg";
export { ForwardRef as ReactComponent };